import { ReactNodeViewRenderer, mergeAttributes } from '@tiptap/react';

import { Figure } from '../helpers';

import CustomImage from './custom-image';
import { ImageCaption } from './image-caption';
import { XingImageView } from './xing-image-view';

declare module '@tiptap/core' {
  // eslint-disable-next-line no-unused-vars
  interface Commands<ReturnType> {
    xingImage: {
      addXingImage: (imageURL: string) => ReturnType;
    };
  }
}

export const XingImage = Figure.extend({
  name: 'xingImage',

  group: 'block',

  content: 'image imageCaption',

  isolating: true,

  addExtensions() {
    return [CustomImage, ImageCaption];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'figure',
      mergeAttributes(HTMLAttributes, {
        class: `node-${this.name}`,
      }),
      ['div', {}, 0],
    ];
  },

  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const {
          state: {
            selection: { $from },
          },
        } = editor;

        if ($from.node().type.name === 'xingImage') {
          return editor.chain().deleteNode(this.name).run();
        }

        return false;
      },
    };
  },

  addCommands() {
    return {
      addXingImage:
        (imageURL) =>
        ({ chain }) => {
          return chain()
            .insertContent({
              type: this.name,
              content: [
                {
                  type: 'image',
                  attrs: {
                    src: imageURL,
                    alt: '',
                  },
                },
                {
                  type: 'imageCaption',
                },
              ],
            })
            .focus()
            .run();
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(XingImageView);
  },
});
